/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import {relayWrap} from '../../box-utils/ParentBox.react.js';

import {FormattedDate, FormattedMessage, IntlShape} from 'react-intl';
import Error from '../system/Error.react.js';
import EmptyContent from '../system/EmptyContent.react';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import MoreLink from '../../box-utils/MoreLink.react';
import MerkMagnitude from './MerkMagnitude.react';
import PanelColumns from '../system/PanelColumns.react';
import './Merk.scss';
import MerkParent from './Merk';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

class Merk extends MerkParent {

    static handlerName = "merk";

    computeRow(merk, idx) {
        let basic = {};

        if (this.props.isPreview) {
			basic = {
				name: 'Firma s.r.o.',
				link: 'https://www.merk.cz/search/detail/cz-5574617/',
				status: {
					id: 1
				},
                turnover: {
                    text: '1 000 000 - 1 999 999 Kč'
                },
				magnitude: {
					id: 110,
					lower_bound_val: 50,
					upper_bound_val: 80,
				}
			};
        } else {
            basic = merk.basic;
        }

        let output = [];

        let hasSomeEconomicData = false;

        output.push(
            <tr key="1"><td className="wrap wholeRow" colSpan="3"><strong className="dativeryValue">{basic.name}</strong> (<MoreLink link={basic.link || ""} service="Merk" />)</td></tr>
        );

		output.push(<tr key="2-status"><td><FormattedMessage defaultMessage="Status" id="merk.status" />:</td><td className="r">{this.getCompanyStatus(basic)}</td><td></td></tr>);

        if (basic.turnover && basic.turnover.text) {
            output.push(<tr key="3"><td><FormattedMessage defaultMessage="Revenue" id="merk.revenue" />:</td><td className="r"><span className="dativeryValue">{basic.turnover.text}</span></td><td></td></tr>);
            hasSomeEconomicData = true;
        }
        if (basic.magnitude && basic.magnitude.id && basic.magnitude.id !== 0) {
            output.push(<tr key="8"><td><FormattedMessage defaultMessage="Employees" id="merk.employees" />:</td><td className="r"><MerkMagnitude data={basic.magnitude.enum ? basic.magnitude.enum : basic.magnitude} /></td><td></td></tr>);
        }

        if (hasSomeEconomicData) {
			if (merk.datum_zaniku) {
				// put the termination date before econonmic data
				output.splice(1, 0, <tr key="2"><td className="wholeRow" colSpan="3"><strong style={{color: 'red'}}><FormattedMessage defaultMessage="Termination date" id="merk.closedDate" /> <FormattedDate value={merk.datum_zaniku} /></strong></td></tr>);
			}
		}
		else {
            output.push(<tr key="0"><td className="wholeRow" colSpan="3"><FormattedMessage defaultMessage="No economic data" id="merk.noEconomicData" /></td></tr>);
			if (merk.datum_zaniku && basic.estab_date) {
				output.push(<tr key="2"><td className="wholeRow" colSpan="3" style={{color: 'green'}}><strong><FormattedMessage defaultMessage="Established" id="merk.establishedDateShort" /> <FormattedDate value={basic.estab_date} /></strong> - <strong style={{color: 'red'}}><FormattedMessage defaultMessage="Terminated" id="merk.closedDateShort" /> <FormattedDate value={merk.datum_zaniku} /></strong></td></tr>);
			}
			else {
				if (basic.estab_date) {
					output.push(<tr key="3"><td className="wholeRow" colSpan="3" style={{color: 'green'}}><strong><FormattedMessage defaultMessage="Established date" id="merk.establishedDate" /> <FormattedDate value={basic.estab_date} /></strong></td></tr>);
				}
				if (merk.datum_zaniku) {
					output.push(<tr key="2"><td className="wholeRow" colSpan="3"><strong style={{color: 'red'}}><FormattedMessage defaultMessage="Termination date" id="merk.closedDate" /> <FormattedDate value={merk.datum_zaniku} /></strong></td></tr>);
				}
			}
        }

        return (
			<div key={idx}>
				<table className="table-spaced-columns company-table">
					<tbody>{output}</tbody>
				</table>
			</div>
        );
    }

    render() {
        try {
            let {addon} = this.props.viewWithData;

            if (addon) {
                addon = safeJSONparse(addon);
                // console.log(addon);
                let list;


                if (addon.merk && Array.isArray(addon.merk) && addon.merk.length > 0) {
                    list = addon.merk;
                } else if (this.props.isPreview) {
                    list = [{}];
                } else {
                    return (
                        <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                            <EmptyContent />
                        </BoxDecorator>
                    );
                }

                return (
                    <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
						<PanelColumns small>
							{list.map((merk, idx) => this.computeRow(merk, idx))}
						</PanelColumns>
                    </BoxDecorator>
                );
            }

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <span>?</span>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(Merk);
